export enum ApartmentDefectFormKey {
  DEFECT_APARTMENT_APPLIANCE = 'DEFECT_APARTMENT_APPLIANCE',
  DEFECT_APARTMENT_TEMPERATURE = 'DEFECT_APARTMENT_TEMPERATURE',
  DEFECT_APARTMENT_VENTILATION = 'DEFECT_APARTMENT_VENTILATION',
  DEFECT_APARTMENT_MINOR_REPAIR_REQUEST = 'DEFECT_APARTMENT_MINOR_REPAIR_REQUEST',
  DEFECT_APARTMENT_PESTS = 'DEFECT_APARTMENT_PESTS',
  DEFECT_APARTMENT_ELECTRICAL = 'DEFECT_APARTMENT_ELECTRICAL',
  DEFECT_APARTMENT_OTHER = 'DEFECT_APARTMENT_OTHER',
  DEFECT_APARTMENT_NAME_UPDATE = 'DEFECT_APARTMENT_NAME_UPDATE',
  PAID_HOUSE_EXPERT_WORK_1_HOUR = 'PAID_HOUSE_EXPERT_WORK_1_HOUR',
}
export enum RealEstateDefectFormKey {
  DEFECT_REAL_ESTATE_PESTS = 'DEFECT_REAL_ESTATE_PESTS',
  DEFECT_REAL_ESTATE_OUTDOOR_CARE = 'DEFECT_REAL_ESTATE_OUTDOOR_CARE',
  DEFECT_REAL_ESTATE_CLEANLINESS = 'DEFECT_REAL_ESTATE_CLEANLINESS',
  DEFECT_REAL_ESTATE_WASTE_BIN_CLEANLINESS = 'DEFECT_REAL_ESTATE_WASTE_BIN_CLEANLINESS',
  DEFECT_REAL_ESTATE_PARKING = 'DEFECT_REAL_ESTATE_PARKING',
  DEFECT_REAL_ESTATE_COMMON_SPACES = 'DEFECT_REAL_ESTATE_COMMON_SPACES',
  DEFECT_REAL_ESTATE_OTHER = 'DEFECT_REAL_ESTATE_OTHER',
}

export enum PaymentsFormKey {
  PAYMENTS_SECURITY_DEPOSIT_RETURN = 'PAYMENTS_SECURITY_DEPOSIT_RETURN',
  PAYMENTS_SECURITY_DEPOSIT_RETURN_MOVING_OUT = 'PAYMENTS_SECURITY_DEPOSIT_RETURN_MOVING_OUT',
  PAYMENTS_QUESTION_FOR_PAYMENT = 'PAYMENTS_QUESTION_FOR_PAYMENT',
}

export enum ContractsFormKey {
  CONTRACT_QUESTION = 'CONTRACT_QUESTION',
  CONTRACT_NEW_PARTY = 'CONTRACT_NEW_PARTY',
  CONTRACT_NEW_RESIDENT = 'CONTRACT_NEW_RESIDENT',
  CONTRACT_TRANSFER = 'CONTRACT_TRANSFER',
}

export enum KeysFormKey {
  KEYS_REQUEST = 'KEYS_REQUEST',
  KEYS_LOST = 'KEYS_LOST',
}

export enum DisturbanceFormKey {
  DISTURBANCE_NEIGHBOUR = 'DISTURBANCE_NEIGHBOUR',
  DISTURBANCE_COMMON_SPACES = 'DISTURBANCE_COMMON_SPACES',
  DISTURBANCE_OTHER = 'DISTURBANCE_OTHER',
}

export enum RenovationFormKey {
  RENOVATION_PAINTING = 'RENOVATION_PAINTING',
  RENOVATION_DIY = 'RENOVATION_DIY',
}

export enum ParkingFormKey {
  PARKING_OTHER_ISSUE = 'PARKING_OTHER_ISSUE',
  PARKING_RENTING_QUESTION = 'PARKING_RENTING_QUESTION',
}

export enum RoomReservationKey {
  CLUB_HOUSE_RESERVATION = 'CLUB_HOUSE_RESERVATION',
}

export enum SaunaFormKey {
  SAUNA_RESERVATION = 'SAUNA_RESERVATION',
}

export enum OtherFormKey {
  OTHER = 'OTHER',
}

/** Keys that map into message category forms */
export type MessageFormKeyType =
  | ApartmentDefectFormKey
  | RealEstateDefectFormKey
  | PaymentsFormKey
  | ContractsFormKey
  | KeysFormKey
  | DisturbanceFormKey
  | RenovationFormKey
  | ParkingFormKey
  | SaunaFormKey
  | OtherFormKey;
